module.exports = __webpack_public_path__ + "img/mop.3da435be.jpg";